export default __webpack_public_path__ + "static/media/page-not-found.f648ed6d.svg";